import React from 'react';
import { Query } from 'react-apollo';
import { GET_CURRENT_USER } from './session.gql';

const withSession = Component => props => (
  <Query query={GET_CURRENT_USER}>
    {({ data, loading, refetch }) => {
      if(!loading) {
        return <Component {...props} session={data} refetch={refetch} />
      }
      return null;
    }}
  </Query>
);

export default withSession;